import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="spinner"></div>
      <p className="loader-text" style={{ fontSize: 12 }}>
        One Stop : For Every Event
      </p>
      <div className="linear-loader"></div>
    </div>
  );
};

export default Loader;
